module.exports = __webpack_public_path__ + "static/img/class_15.ff030a86.jpg";